import React from 'react';
import {Link} from 'react-router-dom';
import {useClientTheme} from '../../../core/context/ClientContext';

/**
 * Shown when the user navigates to a route that is not enabled for the current client
 * (e.g. /dashboard/sales for GO). Also used when API returns 404 with isFeatureDisabled.
 */
const FeatureDisabledPage: React.FC = () => {
  const theme = useClientTheme();
  const appTitle = theme.appTitle ?? 'Dashboard';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <div className="mb-6">
          <div className="text-6xl mb-4">🔒</div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            الميزة غير متاحة
          </h1>
          <p className="text-gray-600">
            هذه الصفحة غير مفعّلة لهذا العميل ({appTitle}). إذا كنت تعتقد أن هذا خطأ، تواصل مع المسؤول.
          </p>
        </div>
        <Link
          to="/dashboard"
          className="inline-block w-full py-3 px-4 rounded-lg bg-brand-600 text-white font-medium hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-primary/30"
        >
          العودة إلى الرئيسية
        </Link>
      </div>
    </div>
  );
};

export default FeatureDisabledPage;
